import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, HeadContent, Link, Outlet, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { ServiceWorkerRegister } from "@/client/components/sw-register";
import { trackScreen } from "@/client/lib/monitoring";
import { pageHead } from "@/client/lib/page";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  head: () => pageHead(),
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  useEffect(() => trackScreen(pathname), [pathname]);
  return (
    <>
      <HeadContent />
      <Outlet />
      <ServiceWorkerRegister />
    </>
  );
}

function NotFound() {
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <div className="text-center">
        <p className="font-display text-3xl font-bold text-slate-800">Página não encontrada</p>
        <Link to="/app" className="mt-4 inline-block text-sm font-medium text-brand-700 underline">
          Voltar ao início
        </Link>
      </div>
    </main>
  );
}
